import React from "react";
import { Link } from "react-router-dom";

const FooterAbout = () => {
  return (
    <div className="footer-about">
      <Link to="/" className="footer-about-logo">
        {/* <img
          src="/images/logo4-BG-REMVOE.webp"
          alt="logo"
          className="footer-about-img"
        /> */}

        {/* <div className="footer-about-logo-group">
          <div className="footer-about-logo-icon">
            <img
              src="/images/logo-fill-icon.webp"
              alt="logo"
              className="footer-about-img"
            />
          </div>
          <div className="footer-about-logo-text">
            <img
              src="/images/logo-text.webp"
              alt="logo"
              className="footer-about-img"
            />
          </div>
        </div> */}
      </Link>
      <p className="footer-about-desc">
        We are a trusted industrial service provider offering specialized
        expertise in dust collection and air pollution control systems.
      </p>
    </div>
  );
};

export default FooterAbout;
